import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  videoCallScheduling: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      pageType: 'agendamento-videochamada',
      pageName: '/webmotors/comprar/detalhe/videochamada/agendamento',
      pageNameTier2: 'videochamada',
      pageNameTier3: 'agendamento',
    },
  },
}
